module.exports = __webpack_public_path__ + "static/media/instagram.408321dd.png";